//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
export default {
  name: "Text",
  props: ["value", "selectedRule", "rules"],
  mounted() {
    let loadedValue = null;
    if (this.value) {
      loadedValue = this.value.value.substring(2, this.value.value.length - 2).replaceAll("','", '§').split('§');
    }

    this.rule = this.rules.filter(
      (rule) => rule.identifier === this.selectedRule
    );
    switch (this.cleanRuleName(this.rule)) {
      case "nome-produto":
        this.fetchProducts();
        this.selectLabel = "Produtos";
        this.storedValue = [];
        this.freeText = false;
        break;
      case "nome-loja":
        this.fetchStores();
        this.selectLabel = "Lojas";
        this.storedValue = [];
        this.freeText = false;
        break;
      case "vendedor":
        this.fetchEmployees();
        this.selectLabel = "Vendedores";
        this.storedValue = [];
        this.freeText = false;
        break;
      case 'tipologia-de-loja':
        this.fetchStoreTypologies();
        this.selectLabel = 'Tipologia de Loja';
        this.storedValue = [];
        this.freeText = false;
        break;
      case 'tags-de-produto':
        this.fetchTags('product_tags');
        this.selectLabel = 'Tags de Produto';
        this.storedValue = [];
        this.freeText = false;
        break;
      case 'tags-de-loja':
        this.fetchTags('store_tags');
        this.selectLabel = 'Tags de Loja';
        this.storedValue = [];
        this.freeText = false;
        break;
      case 'area-de-nielsen':
        this.fetchTags('nielsen_tags');
        this.selectLabel = 'Área de Nielsen';
        this.storedValue = [];
        this.freeText = false;
        break;
      default:
        this.freeText = true;
        this.storedValue = "";
        break;
    }

    if (loadedValue) {
      if (Array.isArray(this.storedValue)) {
        for (let i = 0; i < loadedValue.length; i++) {
          this.storedValue.push(loadedValue[i]);
        }
      } else {
        this.storedValue = this.value.value.substring(2, this.value.value.length - 2);
      }
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
      this.updateValues();
    }
  },
  data: () => ({
    storedValue: null,
    comparisonOperator: null,
    rule: null,
    freeText: false,
    selectDataList: null,
    selectDataListBck: null,
    selectedData: null,
    selectLabel: "",
    loading: false,
    comparisonList: [
      //{label: "escolha comparador", value: null},
      { label: "Igual", value: "in" },
      { label: "Diferente", value: "not in" },
      { label: "Vazio", value: "= null" },
      { label: "Não Vazio", value: "!= null" },
    ],
  }),
  computed: {
    text: {
      get() {
        return this.storedValue;
      },
      set(val) {
        let value = val
        if (val === null) {
          value = [];
        }
        this.storedValue = value;
        if (Array.isArray(value)) {
          this.$emit("input", {
            ...this.value,
            value: this.arrayToString(value),
            comparisonOperator: this.comparisonOperator.value,
          });
        } else {
          this.$emit("input", {
            ...this.value,
            value: "('" + value + "')",
            comparisonOperator: this.comparisonOperator.value,
          });
        }
      },
    },
    //Disables the value input if no operator is chosen or the null operators are selected
    hasSelectedOperator: {
      get() {
        return (
          this.comparisonOperator == null ||
          this.comparisonOperator.value == "= null" ||
          this.comparisonOperator.value == "!= null"
        );
      },
    },
  },
  methods: {
    filterFn(val, update) {
      if (val === "") {
        update(() => {
          this.selectDataList = this.selectDataListBck;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();
        //Se o filter der raia com null values, afunilar o output no backend
        this.selectDataList = this.selectDataListBck.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    fetchProducts: async function () {
      this.loading = true;
      let response = await BackendServices.getRawProducts();
      this.selectDataList = response.data;
      this.selectDataListBck = response.data;
      this.loading = false;
    },
    fetchStores: async function () {
      this.loading = true;
      let response = await BackendServices.getRawStores();
      this.selectDataList = response.data;
      this.selectDataListBck = response.data;
      this.loading = false;
    },
    fetchEmployees: async function () {
      this.loading = true;
      let response = await BackendServices.getRawEmployees();
      this.selectDataList = response.data;
      this.selectDataListBck = response.data;
      this.loading = false;
    },
    fetchStoreTypologies: async function () {
      this.loading = true;
      let response = await BackendServices.getStoreTypologies();
      this.selectDataList = response.data;
      this.selectDataListBck = response.data;
      this.loading = false;
    },
    fetchTags: async function (type) {
      this.loading = true;
      let response = await BackendServices.getTags(type);
      this.selectDataList = response.data;
      this.selectDataListBck = response.data;
      this.loading = false;
    },
    cleanRuleName: function (ruleName) {
      //remove initial number in name /_(.*?)_/
      return ruleName[0].identifier.replace(/(^\d+\s*)(-)/, "");
    },
    updateValues: function () {
      if (
        this.comparisonOperator.value == "= null" ||
        this.comparisonOperator.value == "!= null"
      ) {
        this.$emit("input", {
          ...this.value,
          value: "",
          comparisonOperator: this.comparisonOperator.value,
        });
        this.storedValue = [];
      } else if (Array.isArray(this.storedValue)) {
        this.$emit("input", {
          ...this.value,
          value: this.arrayToString(this.storedValue),
          comparisonOperator: this.comparisonOperator.value,
        });
      } else {
        this.$emit("input", {
          ...this.value,
          value: "('" + this.storedValue + "')",
          comparisonOperator: this.comparisonOperator.value,
        });
      }
    },
    arrayToString: function (array) {
      let result = "";
      if (array.length > 0) {
        result = "(";
        for (let i = 0; i < array.length; i++) {
          result += "'" + array[i] + "',";
        }
        result = result.substring(0, result.length - 1);
        result += ")";
      }
      return result;
    },
  },
  watch: {
    selectedData: function (newValue) {
      this.storedValue = newValue.name;
      this.updateValues();
    },
    value: function () {
      if (this.value.value != this.storedValue) {
        this.rule = this.rules.filter(
          (rule) => rule.identifier === this.selectedRule
        );

        switch (this.cleanRuleName(this.rule)) {
          case "nome-produto":
            this.fetchProducts();
            this.selectLabel = "Produtos";
            this.storedValue = [];
            break;
          case "nome-loja":
            this.fetchStores();
            this.selectLabel = "Lojas";
            this.storedValue = [];
            break;
          case "vendedor":
            this.fetchEmployees();
            this.selectLabel = "Vendedores";
            this.storedValue = [];
            break;
          case 'tipologia-de-loja':
            this.freeText = false;
            this.fetchStoreTypologies();
            this.selectLabel = 'Tipologia de Loja';
            this.storedValue = [];
            break;
          case 'tags-de-produto':
            this.fetchTags('product_tags');
            this.selectLabel = 'Tags de Produto';
            this.storedValue = [];
            this.freeText = false;
            break;
          case 'tags-de-loja':
            this.fetchTags('store_tags');
            this.selectLabel = 'Tags de Loja';
            this.storedValue = [];
            this.freeText = false;
            break;
          case 'area-de-nielsen':
            this.fetchTags('nielsen_tags');
            this.selectLabel = 'Área de Nielsen';
            this.storedValue = [];
            this.freeText = false;
            break;
          default:
            this.freeText = true;
            this.storedValue = "";
            break;
        }

        if (Array.isArray(this.storedValue)) {
          this.storedValue = this.value.value.substring(2, this.value.value.length - 2).replaceAll("','", '§').split('§');
        } else {
          this.storedValue = this.value.value.substring(2, this.value.value.length - 2);
        }
      }
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
    }
  },
};
